import { Link } from "react-router-dom";
import { usePageMeta } from "@/hooks/usePageMeta";
import { BRAND } from "@/lib/site";

export default function AboutPage() {
  usePageMeta(`About Kelly | ${BRAND}`, `Hi, I'm Kelly. ${BRAND} shares handmade gift ideas with real instructions, plus printable gift kits.`);
  return (
    <div className="mx-auto grid max-w-5xl gap-12 px-5 pt-14 sm:px-8 lg:grid-cols-[1fr_1.2fr]" data-testid="about-page">
      <img src="/images/crafts-table.jpg" alt="Craft supplies on a kitchen table" className="aspect-[4/5] w-full rounded-[24px] object-cover" />
      <div>
        <p className="mb-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#23324A]/55">About</p>
        <h1 className="font-heading text-4xl font-semibold text-[#23324A] sm:text-5xl">Hi, I'm Kelly.</h1>
        <div className="mt-6 space-y-4 leading-relaxed text-[#23324A]/90">
          <p>The gifts people keep are rarely the expensive ones. They're the ones somebody made: a coupon book, a jar of something homemade, a card with a wobbly drawing on the front.</p>
          <p>{BRAND} is where I share handmade gift ideas with the parts most posts skip: what to buy, how long it really takes, what it costs, and the steps in order. There are ideas for teachers, for her, for him, for every holiday, for wrapping, and for when you have five dollars and an hour.</p>
          <p>There's also a corner for the youngest makers. Little Hands, Big Gifts is my collection of printables kids fill in, color and give with pride.</p>
          <p>The printables come from my own templates and print at home on US Letter or A4.</p>
        </div>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/blog" className="btn-solid" data-testid="about-ideas-btn">Read gift ideas</Link>
          <Link to="/shop" className="btn-line" data-testid="about-shop-btn">See the printables</Link>
        </div>
      </div>
    </div>
  );
}
